// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDm49D95nek0RIJZw_0_U36cqecNljND-8',
    authDomain: 'mshop-6666.firebaseapp.com',
    databaseURL: 'https://mshop-6666.firebaseio.com',
    projectId: 'mshop-6666',
    storageBucket: 'mshop-6666.appspot.com',
    messagingSenderId: '818757921452'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
